import "./policy-privacy.styles.css";

export const PolicyPrivacy = () => {
  return (
    <div className="rootPolicyPrivacy">
      <div className="bodyPrivacyPolicy">
        <h1 className="titlex03">PRIVACY POLICY </h1>
        <h2 className="subTitlex03"> 27 th of February 2025</h2>
        <div className="boxTextx03">
          <p>
            These policies are drafted in accordance to the regulation on the
            protection of natural persons with regard to the processing of
            personal data and on the free movement of such data and explain what
            data we collect from you, when using any Icredit services or any
            such services provided by any such other brands owned or licensed by
            Icredit.
          </p>
          <p>
            These policies are legally binding, it sets out the basis on which
            any personal or business data we collect from you or your end-users
            using our Products or Services, or that you or your end-users
            provide to us. Please read the following carefully to understand our
            views and practices regarding your personal and/or business data and
            how we aim to treat it. When referring to you, as in anyone browsing
            our sites, or using our Products or Services or APPs we refer to you
            also as You, your, yours, your end-users, company,customer, user.
          </p>
          <p>
            By using our Services and Products, you are accepting and consenting
            to the practices described in these Policies. If you do not agree to
            any part of these Policies, please do not use any of our Services
            nor Products and move away from any and all of our Services and
            Products.
          </p>
          <h4>1. About us</h4>
          <p>
            For the purpose of the relevant data protection regulations, Icredit
            (PTY) Ltd is the data controller of your information. Icredit is a
            company registered in Eswatini. If after reading these Privacy and
            Cookies Policies you still have questions about anything in it,
            please stop using our Services and Products until you fully
            understand and accept all our Terms & Conditions and all our Privacy
            Policies and contact us at [*] .
          </p>
          <h4>2. Information we collect</h4>
          <h5>2.1 Information we collect from you</h5>
          <p>
            This information we collect from you is information that you give us
            by filling in forms on our website https://icreditkyc.com or any
            such other websites that may be owned by us, our parent company or
            our subsidiaries (our sites), when you use our Products or Services
            from our site or our APPs, or by corresponding with us through our
            site, APP, by phone, e-mail, through social media or otherwise. It
            includes information you provide when you register, to use our site
            or our APP, subscribe to our Services, search for a Product, use any
            of our services in our site or our APPs, participate in discussion
            boards or other social media functions on our site or our social
            media channels, enter a referral program, competition, promotion or
            survey and when you report a problem with our site, our Products,
            Services or APPs.
          </p>
          <p>
            The information you give us may include, but is not limited to, your
            full name, mailing and/or residence address, phone numbers, e-mail
            addresses, date of birth, nationality, country of fiscal residence,
            any of your identity documents and proof of address that we deem
            relevant, country of registration of business, any such information
            we deem relevant about your company and its shareholders and
            ultimate beneficiaries, your source of funds account details and
            account holder full name, any such financial and credit or debit
            card information we deem relevant,{" "}
          </p>
          <p>
            personal description and/or photograph of you (and if applicable all
            ultimate beneficiaries) and any such KYC & AML & ATF (know your
            customer & anti money laundering & anti terrorists financing)
            information and when applicable only also any such KYB (know your
            business) information as well as any compliance documentation we
            deem relevant.
          </p>
          <h5>2.2 Information we collect about you</h5>
          <p>
            With regard to each of your visits to our Site or App, or when you
            use our Services or APPs, we will automatically collect the
            following information:
          </p>
          <ul className="ul_x03">
            <li>
              technical information, including the Internet protocol (IP)
              address used to connect your computer or mobile device to the
              Internet, your login information, browser type and version, device
              type and version, time zone setting, any such other identifiers,
              language, browser plug-in types and versions and operating system
              and platform;
            </li>
            <li>
              information about your visit, including the full Uniform Resource
              Locators (URL), clickstream to, through and from our site
              (including date and time), products or things you viewed or
              searched for, page response times, download errors, length of
              visits to certain pages, page interaction information (such as
              scrolling, clicks, and mouse-overs), methods used to browse away
              from the page, and any phone number used to call our customer
              service.
            </li>
            <li className="underline pb">Name & Middle name and Surname(s)</li>
            <span>
              When you receive an email or interact with us or other user(s) of
              our Services or 3rd party financial providers, your name or any
              such other of your information will show up with it. Also, for
              information exchange in relation to KYC, KYB, AML, ATF or any such
              other contractual or legal compliance your name and any such other
              information about you might be exchanged.
            </span>
            <li className="underline pb">Personal information</li>
            <span>
              Enter your birthdate, full address where you live (residence
              address), country of nationality, country of fiscal residence,
              photograph of yourself, a photograph of a valid national identification
              document (ID document), video, audio fingerprints, or
              any other form of identification that we consider appropriate. It
              is your responsibility to keep this information up to date in the
              event of any relevant change, such as but not limited when you
              change your legal name, when you move to live in other address or
              country, or update your ID document when it expires about you
              might be exchanged.
            </span>
            <li className="underline pb">Username - email address</li>
            <span>
              Enter an email address that you'll use to sign in to your Account,
              like in example myname@gmail.com. This email address can be used
              for a few reasons, including to: Help you get back in if you can't
              sign in, like if you forget your password. Get notifications from
              any of our Services.
            </span>
            <li className="underline pb">Country</li>
            <span>
              To assure you can use certain Services we need to check you are
              not a resident outside of Eswatini. Also, to comply with the
              regulation guidelines we need to check if you are a Eswatini
              territory User or not, in which case the Eswatini data protection
              law requires such users´ data from Eswatini users to be stored on
              server(s) within a country of the Eswatini Union. Also, for us to
              comply with our current and future contractual obligations and to
              comply with applicable laws, rules and regulations at any given
              time, such as KYC, KYB, AML, ATF and applicable TAX legislations
              and so forth we need to check the country of residence and the
              country of fiscal residency. When you pass a KYC, you provide us
              with personal information that includes your name, country and a
              password and other information, you might choose to provide us
              with information — like an email address or your country from
              where you access our sites or APPs to receive the information you
              are accessing, such as a website page or information about our
              service or APPs or when downloading our APP or when receiving
              updates about our Services or our sites or APPs.
            </span>
            <li className="underline pb">Your apps & devices</li>
            <span>
              We collect information about the APPs, browsers, and devices you
              use on your device to access our Services, which helps us provide
              features like automatic product updates and dimming your screen if
              your battery runs low or to show you the information we deem
              relevant or in a certain language the information or service you
              access depending on your device’s information.
            </span>
            <span>
              The information we collect includes unique identifiers,
              device/model type and settings, SIM mobile carrier name, SIM home
              country carrier, SIM, SIM telephone number if accessible, your
              device contacts list/phone book information if specifically
              authorised by you, your social network contacts list if your login
              is linked by you to one of those services, time zone, screen
              resolution and size if available, operating system, and installed
              applications APP names and version number and device file names
              and types. We also collect information about the interaction of
              your apps and devices with our services, including IP address, MAC
              address, crash reports, system activity, and the date, time, and
              referrer URL of your request.
            </span>
            <span>
              We collect this information when a service on your device contacts
              our servers or our apps — for example, when you install our APP
              from the Play Store or App Store.{" "}
            </span>
            <li className="underline pb">Your location information</li>
            <span>
              We collect information about your location when you use our
              services, which helps us offer features like nearby devices
              features that we may offer now or in the future, such as but not
              limited to Wi-Fi hotspots locations and hotspots names, and it
              helps us to comply with the regulations by checking if you are a
              Eswatini territory User or not, in which case the data protection
              law requires us to store such users´ data to be stored on
              server(s) within a country of Eswatini.
            </span>
          </ul>
          <h4>
            Your location can be determined with varying degrees of accuracy by:
          </h4>
          <ul className="ul_x04">
            <li>
              - Country of SIM, connected Mobile service provider (home or
              roaming). Name & country of your internet service provider (be it
              a fixed line or a wireless/mobile service provider), your SIM
              provider name and country code or roaming provider name and
              country code of the SIM in your device.
            </li>
            <li>- IP address and MAC address</li>
            <li>
              - GPS location information, such as but not limited to the
              country.
            </li>
            <li>
              - Sensors data from your device, i.e. pressure data to calculate
              estimated altitude.
            </li>
            <li>
              - Information about things near your device, such as Wi-Fi access
              points, cell towers, and Bluetooth-enabled devices.
            </li>
            <li>
              - The types of location data we collect depends in part on your
              device and account settings but mainly on the permissions access
              you provide us on your device. Certain feature of our Services may
              not function without certain such permissions. For example, you
              can turn your Android device’s location on or off using the
              device’s settings which is independent of our App(s).
            </li>
          </ul>
          <ul className="ul_x03 underline">
            <li>Your privacy controls</li>
          </ul>
          <p>
            You have choices regarding the information we collect and how it's
            used. You can revoke certain permission you make have provided
            through our APP by changing the settings of certain permissions in
            the settings menu of your device. Other permissions are mandatory to
            make use of our Services and can´t be revoked after you accept our
            Terms and Conditions (T&Cs) and Privacy Policies prior to creating
            an account with us or when browsing our sites. If you do not agree
            with any part of whole of any of our T&Cs or additional T&Cs or our
            Privacy & Cookies Policies or any of these or any other additional
            T&Cs and additional Privacy Policies or any such information we
            access, then simply stop using our services, uninstall all our APPs
            and browse away from all our sites.
          </p>
          <p>
            When you visit our Site, app or use our Services or Products, we
            collect information about which of the Services you’ve used, from
            where you´ve used them and how you’ve used them. Examples, but not
            limited to, of this information include:
          </p>
          <ul className="ul_x04">
            <li>
              - Usage information on our Site or mobile app (e.g., pages you
              visit on the Site, webpage from which you linked prior to ending
              up on our Site).
            </li>
            <li>
              - Time and date of your activities and location from which you
              browsed our Site or app.
            </li>
            <li>
              - Time and date of your activities and location from which you
              browsed our Site or app.
            </li>
            <li>
              - Information about your transaction’s destination/source device
              and such account of each device of a same transaction identifier,
              including the date, time, amount, beneficiary/sender details, IP
              address, MAC address, location, country and other details of all
              device(s) that are part of a same transaction performed between
              nearby user´s devices of our Services.
            </li>
            <li>
              - Device ID, IP address, MAC address and the kind of browser or
              app and the type of computer or mobile device you use.
            </li>
            <li>
              - Name of your internet service provider or SIM provider or
              country code or roaming country code of the mobile operator SIM in
              your device; and Operating system version.
            </li>
          </ul>
          <h4>2.3 Information we get from 3rd parties</h4>
          <p>
            This 3rd party information that we receive about you if you use any
            of the other websites we operate or the other services we provide or
            if you browse 3rd party sites or use 3rd arty APPs that might link
            to our sites or APPs, for example but not limited to provide to
            their users certain or all of our services or who provide marketing
            or advertising services to us.
          </p>
          <p>
            In this case we or the 3rd party might have informed you when we
            collected that data if we intend to share those data internally and
            combine it with data collected on our site. We aim to tell you for
            what purpose we will share and combine your data in future. We are
            working closely with third parties (including, for example, business
            partners, sub-contractors in technical, payment and delivery
            services, advertising networks, analytics providers, search
            information providers, credit reference agencies, financial services
            providers, etc.). We aim to notify you when we receive information
            about you from them and the purposes for which we intend to use that
            information.
          </p>
          <p>
            We may collect Personal Information about you from other users, our
            affiliates, and third parties, as permitted by law or as authorized
            to be accessed by such other users. For example, we may collect
            information from third-party verification services, credit bureaus,
            financial institutions, mailing list providers, other users of our
            Services, and publicly available sources to verify your identity or
            fiscal residence or to obtain certain other information about you
            such as but not limited your email, contact phones and address etc.
            We may also collect information about you from third parties in
            connection with any identity or account verification process, fraud
            detection process, or collection procedure, or as may otherwise be
            required by applicable law or as we deem fit to comply with our
            contractual obligations with 3rd parties and to ensure we have
            sufficient information about you for us to perform reasonable checks
            for KYC, KYB, AML, ATF, etc.
          </p>
          <p>
            We may collect Personal Information about you from other users, our
            affiliates, and third parties, as permitted by law. For example, we
            may collect information from third-party verification services,
            credit bureaus, financial institutions, mailing list providers, and
            publicly or otherwise available sources to verify your identity or
            fiscal residence. We may also collect information about you from
            third parties in connection with any identity or account
            verification process, fraud detection process, compliance process,
            or collection procedure, or as may otherwise be required by
            applicable law.
          </p>
          <h4>3. How we use your information</h4>
          <h5>3.1 To provide our services </h5>
          <p>
            We may use your Personal Information to fulfil requests for
            Products, Services, or information, including information about
            potential or future Services, including but not limited to:
          </p>
          <ul className="ul_x03">
            <li>
              Manage individual information and accounts, respond to questions,
              comments, and other requests;
            </li>
            <li>
              Verify an individual’s identity as being authentic or not and/or
              comparing your selfie image or video against your
              government-issued identification;
            </li>
            <li>
              Process payment for products or Services purchased, applications
              and transactions;
            </li>
            <li>
              Provide access to certain areas, functionalities, and features of
              our services and allow you to register for events or certain
              features of our Services.
            </li>
          </ul>
          <h5>3.2 For internal business purposes</h5>
          <p>
            We may use your Personal or Business Information for its internal
            business purposes, including but not limited to:
          </p>
          <ul className="ul_x03">
            <li>
              Measure interest in Services, develop new Products and Services or
              improve existing Products and Services.
            </li>
            <li>
              Ensure internal quality control and communicate about individual
              accounts and activities on Services systems.and{" "}
            </li>
            <li>
              Comply with regulatory requirements and prevent potentially
              prohibited or illegal activities.
            </li>
            <li> Enforce our Terms of Use.</li>
            <li>
              Protect the safety of any account, to address fraud, security or
              technical issues, or to protect the Company’s rights or property.
            </li>
            <li>
              Any of your personal or business information required to operate
              and provide to our users our Services and Products will be shared
              and stored on 3rd party Suppliers servers or 3rd party Service
              Providers or any such other 3rd parties as required to provide any
              or all of our Services.
            </li>
          </ul>
          <h5>3.3 For marketing purposes</h5>
          <p>
            We may analyse and use your Personal or Business Information to
            provide you with materials about offers, Products, and Services that
            may be of interest, including new content or Services, such uses
            include but are not limited to:
          </p>
          <ul className="ul_x03">
            <li> To tailor content, advertisements, and offers.</li>
            <li>
              To notify you about offers, products, and services that may be of
              interest to you or to provide Services to you and our sponsors.
            </li>
            <li>
              For other purposes disclosed at the time you provide Personal
              Information; and otherwise with your consent.
            </li>
            <li>
              By using any of our Services or Products you consent to our
              Privacy and Cookies Policies.
            </li>
          </ul>
          <h4>4. Legal Basis for using user’s information</h4>
          <p>
            According to data protection regulation we must have a legal basis
            to use your personal information, and will be one of the following:
          </p>
          <span className="pb">
            ▪ <span className="underline">Consent</span>
          </span>
          <p>
            When you agree to provide us information and allow us to collect it.
          </p>
          <span className="pb">
            ▪
            <span className="underline">
              It is necessary for the performance of a contract by us
            </span>
          </span>
          <p>
            When such information is necessary to perform a contract between us
            and the user or between us and a 3rd party contract.{" "}
          </p>
          <span className="pb">
            ▪
            <span className="underline">
              Compliance with a legal obligation{" "}
            </span>
          </span>
          <p>
            When Icredit as a controller or as a party to a contract with a 3rd
            party has a legal or contractual obligation to perform the
            processing according to regulation or by contract.
          </p>
          <span className="pb">
            ▪ <span className="underline">Legitimate interest</span>
          </span>
          <p>
            When processing any of your information is necessary for the purpose
            of legitimate interest of the controller or a 3rdparty, except when
            such interest is overridden by fundamental rights and freedom of the
            users which require protection of personal data.{" "}
          </p>
          <h4>5. Sharing your data</h4>
          <p>
            We may share your personal data with 3rd parties in order to provide
            you with our services in the following ways
          </p>
          <span className="pb">
            ▪ <span className="underline">Business partners. </span>
          </span>
          <p>
            We may share Personal Information with our business partners,
            subsidiaries, parent company, affiliates, and for our affiliates’
            internal business purposes or to provide you with a product or
            service that you have requested
          </p>
          <span className="pb">
            ▪ <span className="underline">5.2 To verify your identity. </span>
          </span>
          <p>
            For example, we may share information about you, but not limited to:
            with credit reporting agencies to verify your Social Security number
            or with 3rd party to verify authenticity of your identification
            document.
          </p>
          <p>
            The personal information we have collected from you will be shared
            with fraud prevention agencies who will use it to prevent fraud and
            money-laundering and to verify your identity. If fraud is detected,
            you could be refused certain services, finance, or employment.
            Further details of how your information will be used by us and these
            fraud prevention agencies, and your data protection rights, can be
            found in our privacy policy. Further details of how your information
            will be used by us and these fraud prevention agencies, and your
            data protection rights.{" "}
          </p>
          <p>
            Whenever fraud prevention agencies transfer your personal data
            outside of the contry where this service is provided, they impose contractual
            obligations on the recipients of that data to protect your personal
            data to the standard required in the country where this service is provided. They
            may also require the recipient to subscribe to ‘international
            frameworks’ intended to enable secure data sharing.
          </p>
          <span className="pb">
            ▪
            <span className="underline">
              5.3 With vendors and service providers
            </span>
          </span>
          <p>
            (i) provision of IT and related services; (ii) provision of
            information and Services you have requested; (iii) payment
            processing; and (iv) customer service activities; (v) fraud
            prevention; (vi) analytics services; and (vii) in connection with
            the provision of the Services. These service providers have
            contracted with us to only use the Personal Information for the
            purpose(s) for which the data were originally collected or may
            otherwise be lawfully processed.
          </p>
          <span className="pb">
            ▪{" "}
            <span className="underline">
              5.4 With third parties for legal reasons
            </span>
          </span>
          <p>
            We may share information about you if we reasonably believe that
            disclosing the information is needed to:
          </p>
          <ul className="ul_x03">
            <li>
              Comply with any valid legal or contractual process, governmental
              request, or applicable law, rule, or regulation.
            </li>
            <li>
              Investigate, remedy, or enforce potential Terms of Service or
              Privacy suspected violations.
            </li>
            <li>
              {" "}
              Protect the rights, property, and safety of us, our users, or
              others or Detect and/or report any fraud or security concerns.
            </li>
            <li> To comply with KYC, KYB AML and ATF.</li>
          </ul>
          <h4>6. Cookies and analytics technologies</h4>
          <h5>6.1 Cookies</h5>
          <p>
            We use various technologies to collect information, including
            cookies, and web beacons. Cookies are small data files stored on
            your hard drive or in device memory that help us improve our site
            and your experience, see which areas and features of our site are
            popular, and count visits. We may use cookies on our site when you
            are logged in so that we can remember this fact. This prevents you
            from having to log in every single time you visit a new page. These
            cookies are typically removed or cleared when you log out to ensure
            that you can only access restricted features and areas when logged
            in. This site offers newsletter or email subscription services and
            cookies may be used to remember if you are already registered and
            whether to show certain notifications which might only be valid to
            subscribed/unsubscribed users. When you submit data through a form
            such as those found on contact pages or comment forms cookies may be
            set to remember your user details for future correspondence. Most
            web browsers are set to accept cookies by default. If you prefer,
            you can usually choose to set your browser to remove or reject
            browser cookies. Please note that if you choose to remove or reject
            cookies, this could affect the availability and functionality of our
            site. For more information about cookies visit:
            http://www.allaboutcookies.org/
          </p>
          <p>
            During the use of our website or app we mainly use three kind of
            cookies:
          </p>
          <ul className="ul_x03">
            <li>
              Session cookies, they help websites recognise users and the
              information provided when they navigate through. Only retain
              information for as long as they are on website.
            </li>
            <li>
              Permanent cookies, they are capable of providing websites with
              user preferences, setting and information for future visits,
              improving their experience. They remain in operation even after
              the browser has closed. The law states that permanent cookies must
              be deleted after 12 months.
            </li>
            <li>
              Third party cookies, they are installed by third parties with the
              aim of collecting certain information from web users as the
              behaviour or spending habits. They are commonly used by
              advertisers who want to ensure that products and services are
              marketed towards the right target audience.
            </li>
          </ul>
          <p>
            On most web browsers, you could find a “help” section on the
            toolbar. Please refer to this section for information on how to
            receive notification when you are receiving a new cookie and how to
            turn cookies off. We recommend that you leave cookies turned on
            because they allow you to take advantage of some of the Service
            features.
          </p>
          <p>
            These Privacy and Cookies Policies also cover the use of cookies by
            our Site only and do not cover the use of cookies by any business
            partners or advertisers on our Site or by any 3rd party.
          </p>
          <p>
            We may also use analytics tools such as but not limited to Google
            Analytics to collect information regarding visitor behaviour and
            visitor demographics on our Site, and to develop website content and
            for marketing purposes. This analytics data is not tied to any
            Personal Information. For more information about Google Analytics,
            please visit www.google.com/policies/privacy/partners/. You can opt
            out of Google’s collection and Processing of data generated by your
            use of the Site by going to http://tools.google.com/dlpage/gaoptout.
          </p>
          <h5>6.2 Clear Gifs (web beacons)</h5>
          <p>
            We may employ a software technology called clear gifs (a.k.a. Web
            Beacons) that help us better manage content on our Site by informing
            us what content is effective. Clear gifs are tiny graphics with a
            unique identifier, similar in function to cookies, and are used to
            track the online movements of Web users. In contrast to cookies,
            which are stored on a user’s computer hard drive, clear gifs are
            embedded invisibly on Web pages and are about the size of the period
            at the end of this sentence. We may tie the information gathered by
            clear gifs to our customers’ Personal Information. We may use clear
            gifs in our HTML-based emails to let us know which emails have been
            opened by recipients. This allows us to gauge the effectiveness of
            certain communications and the effectiveness of our marketing
            campaigns.
          </p>
          <h4>7. Profiling and automated decision making</h4>
          <p>
            It is probable that we use some instances of your data to customise
            our Services and the information we provide to you, and to address
            your needs. For which we take all necessary measures to ensure that
            your privacy and security are protected, and we only use
            pseudonymised data where ever possible.
          </p>
          <p>
            As we are a highly technical and innovative company, we may use
            Automated Decision Making (ADM) in order to improve your experience,
            or to help fight financial crime.
          </p>
          <h4>8. Where we store your information</h4>
          <p>
            All information you provide to us is stored on a secure server or
            servers. Any transactions, specifically any payment transactions are
            aimed to be stored encrypted. Where we have given you (or where you
            have chosen) a password which enables you to access certain parts of
            our site, app or Services, you are responsible for keeping this
            password confidential. We ask you not to share a password with
            anyone. Unfortunately, the transmission of information via the
            internet is not completely secure.
          </p>
          <p>
            Although we aim to do our best to protect your personal data, we
            cannot guarantee the security of your data transmitted to our site
            or app; any transmission is at your own risk. Once we have received
            your information, we aim to use strict procedures and security
            features to try to prevent unauthorized access. Any information from
            the country where this service is provided residents are aimed to be 
            stored on secure servers on AWS-SA
          </p>
          <h4>9. How long we keep your information</h4>
          <p>
            We will retain your information for as long as you use our Services
            or as necessary thereafter to fulfil the purpose(s) for which it was
            collected. We do not control the use of your data by any 3rd party;
            however we will delete data under our control that is no longer
            required by any contract to which we are or will be a party to or by
            any relevant law or jurisdiction where we operate at any time.
          </p>
          <h4>10. Your Rights</h4>
          <p>
            You have the right to ask us not to process your personal data for
            marketing purposes. We will inform you (before collecting your data)
            if we intend to use your data for such purposes or if we intend to
            disclose your information to any third party for such purposes. You
            can exercise your right to prevent such processing by checking
            certain boxes on the forms we use to collect your data.{" "}
          </p>
          <ul className="ul_x04">
            <li>
              - You have the right to correct any personal information we have
              about you that is not accurate or not updated.
            </li>
            <li>
              - You have the right to ask us to delete your personal
              information.{" "}
            </li>
            <li>
              - You have the right to ask us to provide you with your personal
              information we held about you.
            </li>
            <li>
              - You have the right to withdraw your consent given to us to
              process your personal data.
            </li>
            <li>
              - You have the right to tell us about how we use your personal
              information.
            </li>
          </ul>
          <p>
            You can exercise those rights at any time by contacting us at [*]
          </p>
          <h4>11. Security</h4>
          <p>
            We take commercially-reasonable measures to protect the data you
            have given us from accidental or intentional manipulation, loss,
            destruction or access by unauthorized persons. However, please be
            aware that no transmission of Personal Information over the Internet
            or the electronic storage of this information can be absolutely
            guaranteed to be free from unauthorized use or access. Before
            submitting any Personal Information via any of our Site, Services or
            our APPs, please keep in mind these risks and know that you do
            provide any of your personal or business information to us and
            indirectly automatically to certain 3rd parties (i.e. to PFS and
            others) at your own risk.
          </p>
          <h4>12. Changes to our privacy policies</h4>
          <p>
            We may change these Privacy and Cookies Policies from time to time.
            If we do, we will post the revised Policies on this page with a new
            date of when it was last updated by us. All changes will become
            effective when posted unless indicated otherwise. If we make any
            material changes we may choose, at our sole discretion, to post a
            notice on this website or to potentially send a notification to your
            app or to your email prior to the change becoming effective. We
            encourage you to periodically review this page for the latest
            information on our privacy practices.
          </p>
          <h4>13. Exclusion of right of use</h4>
          <p>
            If you are not a resident of Eswatini, please move away from any and
            all of our services, and stop using all of our websites or APPs. You
            must be living / residing in Eswatini to use our service.
          </p>
          <h4>14. Disclosure of information</h4>
          <p>
            By using any of our Services, websites or apps you agree irrevocably
            that we have the right to share your personal information with:
          </p>
          <p>
            Any member of our staff or related entity within our group, parent
            or holding company or subsidiaries. – selected third parties
            including: – businesses, financial service providers, banks, credit
            or debit card providers, suppliers and sub-contractors, service
            providers, for the performance of any contract we enter into with
            you or with third parties or for providing our services through our
            apps, products, and our infrastructure, such as including but not
            limited by:
          </p>

          <ul className="ul_x04">
            <li>
              - analytics and search engine providers that assist us in the
              improvement and optimization of our sites or apps;
            </li>
            <li>
              - Credit reference agencies for the purpose of assessing your
              credit score where this is a condition of us entering into a
              contract with you. We will disclose your personal information to
              third parties:
            </li>
            <li>
              - KYC/AML/Compliance agencies or third party contracted companies
              for such purpose of assessing your identity, living or fiscal
              address, anti-money laundry checks and checks for source of funds
              of money and crypto or other such services where this is a
              condition of us entering into a contract with you or such third
              party. We will disclose your personal information to third
              parties.
            </li>
          </ul>
          <p>
            In the event that we sell or buy any business or assets, in which
            case we will disclose your personal data to the prospective seller
            or buyer of such business or assets.
          </p>
          <p>
            If we are under a duty to disclose or share your personal data in
            order to comply with any legal obligation, or to protect the rights,
            property, or safety of Icredit, or Icredit owners, or any of its
            officers, shareholders, customers, or others. This includes
            exchanging information with other companies and organizations for
            the purposes of financial compliance, customers fiscal address
            compliance verifications to comply with applicable laws, fraud
            protection and credit risk reduction and so forth.
          </p>
          <p>
            Using any of our Service(s), website(s) or App(s) means you accept
            these Privacy and Cookies Policies but also that you accept
            irrevocably all our Terms of Service (Terms and Conditions or T&Cs)
            and any Additional Terms and Conditions, so read them carefully.
          </p>
          <h4>15. Contact us</h4>
          <p>
            If you have questions or comments about these Privacy and Cookies
            Policies, please contact us contact us through this website contact
            form or contact your Merchant directly if you passed your KYC
            through their platform
          </p>
        </div>
      </div>
    </div>
  );
};
